import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks';
import { formatCommas, getTrimmedString } from 'components/project/ClerkScreen/shared/utils/common';
import {
  BoxAttribute,
  BoxSubAttribute,
} from 'components/project/FloorBidderScreen';
import { getProductAttribute, getAttributeItem, getCrJsonProp } from '../../../../stores/utils';
import {
  Container, NestedAttributes, VerticalAttributes, HorizontalAttributes,
} from './Styles';

const ItemDetailsContainer = ({ flowDirection }) => {
  const {
    BidStore: { auctionProduct },
  } = useStores();

  const getAttribute = (key) => getProductAttribute(auctionProduct, key, '-');


  const keyValueToArray = (value, delimiter) => {
    if (!value) return null;
    return value.split(delimiter);
  };

  const getInspectionHeaderKeyValues = (valueToParse) => {
    if (!valueToParse) return { keys: null, values: null };
    const parts = keyValueToArray(valueToParse, ',');
    const keys = [];
    const values = [];
    parts.forEach((keyValue) => {
      const [key, value] = keyValueToArray(keyValue, '=');
      keys.push(getTrimmedString(key));
      values.push(getTrimmedString(value));
    });
    return { keys, values };
  };

  const sanitizeDocs = (value) => {
    let sanitized = value;
    sanitized = value.replace('SALVAGE HISTORY; SALVAGE HISTORY', 'SALVAGE HISTORY');
    return sanitized;
  }
  const cr = getAttributeItem('ConditionReport', auctionProduct?.attributes);
  const crTotalScore = getCrJsonProp(cr, 'TotalScore');
  const cosmScore = getCrJsonProp(cr, 'CosmeticScore') || '-';
  const mechScore = getCrJsonProp(cr, 'MechanicalScore') || '-';
  const inspectionHeader = getAttributeItem('InspectionHeader', auctionProduct?.attributes);
  const inspectionKeyValues = getInspectionHeaderKeyValues(inspectionHeader?.value);
  const inspectionHeaderKeys = inspectionKeyValues?.keys;
  const engKeyIndex = inspectionHeaderKeys?.findIndex((key) => "".concat(key).trim() === 'EM');
  const engScore = inspectionKeyValues?.values?.slice(engKeyIndex, engKeyIndex + 1)[0] || '-';
  const frKeyIndex = inspectionHeaderKeys?.findIndex((key) => "".concat(key).trim() === 'FR');
  const frScore = inspectionKeyValues?.values?.slice(frKeyIndex, frKeyIndex + 1)[0] || '-';
  const trKeyIndex = inspectionHeaderKeys?.findIndex((key) => "".concat(key).trim() === 'TR');
  const trScore = inspectionKeyValues?.values?.slice(trKeyIndex, trKeyIndex + 1)[0] || '-';
  const formattedDoc = sanitizeDocs(getAttribute('Documents'));
  const mileageAttr = getAttribute('Mileage');
  const miles = isNaN(mileageAttr) ? mileageAttr : formatCommas(mileageAttr);
  const location = getAttribute('Location');

  return (
    <Container flowDirection={flowDirection}>
      <NestedAttributes flowDirection={flowDirection}>
        <BoxAttribute label="CR" value={crTotalScore} fontSize="large" />
        <VerticalAttributes>
          <BoxSubAttribute label="ENG" value={engScore} />
          <BoxSubAttribute label="FR" value={frScore} />
          <BoxSubAttribute label="TR" value={trScore} />
        </VerticalAttributes>
        <HorizontalAttributes>
          <BoxSubAttribute label="COSM" value={cosmScore} />
          <BoxSubAttribute label="MECH" value={mechScore} />
        </HorizontalAttributes>
      </NestedAttributes>
      <BoxAttribute label="MI/HR" value={miles} fontSize="large" />
      <BoxAttribute label="DOC" value={formattedDoc} fontSize={`v-${flowDirection}`} />
      <BoxAttribute label="LOC" value={location} fontSize="medium" />
    </Container>
  );
};

ItemDetailsContainer.propTypes = {
  flowDirection: PropTypes.string,
};

ItemDetailsContainer.defaultProps = {
  flowDirection: 'row',
};

export default observer(ItemDetailsContainer);
